import { defineStore } from 'pinia'

export const useTranslationsStore = defineStore('TranslationsStore', {
  state: () => ({
    translations: null,
  }),
  getters: {
    getTranslations: state => {
      if (!state.translations) {
        const storedTranslations = localStorage.getItem('translations')
        if (storedTranslations) {
          return JSON.parse(storedTranslations)
        } else return []
      } else {
        return toRaw(state.translations)
      }
    },
  },
  actions: {
    async fetchTranslations() {
      try {
        const { $config } = useNuxtApp()

        const data = await $fetch('/translations', {
          baseURL: `${$config.public.BACKEND_URL}/api`,
          timeout: 45000,
          retry: 3,
          retryDelay: 2000,
        })

        this.translations = toRaw(data)

        localStorage.setItem('translations', JSON.stringify(this.translations))

        return this.translations
      } catch (error) {
        console.error(error)

        return null
      }
    },
  },
})
